import React from "react";
import { Camera, CheckCircle, Linkedin, Award } from "lucide-react";

const GOOGLE_SV_BADGE = "https://customer-assets.emergentagent.com/job_sos-activity-cards/artifacts/wr288sey_Google-Street-View-Trusted-Badge-2021.png";
const RICCARDO_IMG = "https://customer-assets.emergentagent.com/job_riccardo-sos-google/artifacts/4eu97hbx_Test%20ico%20TNX%20Ricca.png";
const GOPRO_IMG = "https://customer-assets.emergentagent.com/job_9aee3f9a-9ba9-47c5-9ef1-87f76cda4250/artifacts/b4icib11_image.png";

const COLLE_PUZZLE_IMG = "https://customer-assets.emergentagent.com/job_1794d4ee-6a77-4bf9-8d94-fce67f907c43/artifacts/qqz4ylfr_chrome_k0ZTbU0uuF.png";

const VirtualTourSection = () => (
  <section id="virtual-tour" className="py-16 bg-[#0a0e1a] relative overflow-hidden" data-testid="virtual-tour-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* Section header */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 bg-[#34A853]/15 text-[#34A853] px-4 py-1.5 rounded-full font-bold text-xs mb-4">
          <Camera className="w-4 h-4" /> VIRTUAL TOUR 360
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-white mb-3" style={{ fontFamily: "'Poppins',sans-serif" }}>
          Chi c'e' dietro la <span className="text-[#34A853]">fotocamera</span>
        </h2>
        <p className="text-gray-400 max-w-xl mx-auto text-sm">
          Niente bot, niente AI. Un professionista certificato, attrezzatura top e la passione per far brillare la TUA attivita'.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-4 text-xs text-gray-500">
          <span><strong className="text-[#FBBC04]">51 recensioni</strong> tutte a 5 stelle su Google</span>
          <span><strong className="text-[#4285F4]">7.000+</strong> foto pubblicate</span>
          <span><strong className="text-[#34A853]">52 milioni</strong> di visualizzazioni generate</span>
          <span>Quanti fotografi Google Street View conosci con questi numeri?</span>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 items-start">
        {/* LEFT — Riccardo Rossi Profile */}
        <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-6 md:p-8" data-testid="virtual-tour-profile">
          <div className="flex items-start gap-5 mb-6">
            {/* Google SV Badge */}
            <div className="flex-shrink-0">
              <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center shadow-lg p-2 relative">
                <img src={GOOGLE_SV_BADGE} alt="Google Street View Certificato" className="w-full h-full object-contain" />
              </div>
              <p className="text-center mt-2">
                <span className="text-[10px] text-gray-500 block">Street View</span>
                <span className="text-[11px] text-[#34A853] font-bold">certificato</span>
              </p>
            </div>
            {/* Name & title */}
            <div className="flex-1">
              <h3 className="text-2xl font-black text-white" style={{ fontFamily: "'Poppins',sans-serif" }}>
                Riccardo Rossi
              </h3>
              <p className="text-gray-400 text-sm mt-1">Fotografo Google Street View Certificato</p>
              {/* Badges */}
              <div className="flex flex-wrap gap-2 mt-3">
                <span className="inline-flex items-center gap-1.5 bg-[#4285F4]/10 border border-[#4285F4]/30 text-[#93c5fd] text-xs font-bold px-3 py-1 rounded-full" data-testid="badge-google-cert">
                  <Award className="w-3.5 h-3.5" />
                  Google Certified 2016
                </span>
                <a href="https://www.linkedin.com/in/riccardorossi1984googletnx" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-[#0A66C2]/10 border border-[#0A66C2]/30 text-[#60a5fa] text-xs font-bold px-3 py-1 rounded-full hover:bg-[#0A66C2]/20 transition-colors" data-testid="badge-linkedin">
                  <Linkedin className="w-3.5 h-3.5" />
                  LinkedIn Premium
                </a>
              </div>
            </div>
          </div>
          {/* Bio */}
          <p className="text-gray-300 text-sm leading-relaxed">
            Dal <strong className="text-white">2016</strong> aiuto aziende e professionisti a distinguersi su <strong className="text-white">Google Maps</strong> con virtual tour immersivi. Niente bot, niente AI: <strong className="text-white">parlo io, in carne ed ossa</strong>.
          </p>
          {/* Stats mini */}
          <div className="grid grid-cols-3 gap-3 mt-6">
            {[
              { num: "9+", label: "Anni attivi", color: "text-[#ff6b35]" },
              { num: "7K", label: "Foto 360", color: "text-[#4285F4]" },
              { num: "52M", label: "Views", color: "text-[#34A853]" },
            ].map(s => (
              <div key={s.label} className="text-center bg-white/[0.03] rounded-xl py-3 border border-white/[0.06]">
                <span className={`text-xl font-black ${s.color}`}>{s.num}</span>
                <span className="block text-gray-500 text-[10px] mt-0.5 uppercase tracking-wide">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — I Nostri Strumenti */}
        <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-6 md:p-8" data-testid="virtual-tour-equipment">
          <div className="flex items-center gap-2 mb-6">
            <Camera className="w-5 h-5 text-[#4285F4]" />
            <h3 className="text-lg font-black text-white">I Nostri Strumenti</h3>
          </div>

          {/* GoPro MAX 360 */}
          <div className="flex flex-col sm:flex-row items-center gap-6 mb-6">
            <div className="w-36 h-36 bg-black/40 rounded-2xl flex items-center justify-center flex-shrink-0 border border-white/10 p-3">
              <img src={GOPRO_IMG} alt="GoPro MAX 360" className="w-full h-full object-contain" />
            </div>
            <div>
              <h4 className="text-xl font-black text-white mb-3">GoPro MAX 360°</h4>
              <ul className="space-y-2">
                {[
                  "Video 5.6K30 sferici",
                  "Foto 16.6MP a 360°",
                  "Stabilizzazione HyperSmooth",
                  "Impermeabile",
                ].map(spec => (
                  <li key={spec} className="flex items-center gap-2 text-gray-300 text-sm">
                    <CheckCircle className="w-4 h-4 text-[#34A853] flex-shrink-0" />
                    {spec}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Descrizione attrezzatura */}
          <div className="bg-[#34A853]/5 border border-[#34A853]/20 rounded-xl p-4">
            <p className="text-gray-300 text-sm leading-relaxed">
              L'attrezzatura professionale che utilizzo per i tuoi <strong className="text-white">virtual tour</strong>. Qualita' cinematografica per <strong className="text-white">far brillare i tuoi spazi</strong>.
            </p>
          </div>

          {/* CTA */}
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <a
              href="https://wa.me/393420380578?text=Ciao%20Riccardo!%20Vorrei%20un%20virtual%20tour%20360%C2%B0%20per%20la%20mia%20attivit%C3%A0"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 bg-[#34A853] hover:bg-[#2d9249] text-white rounded-full py-3 text-sm font-bold text-center transition-colors hover:scale-[1.02] transform"
              data-testid="virtual-tour-cta-wa"
            >
              Prenota il tuo Virtual Tour
            </a>
            <button
              onClick={() => document.getElementById('pacchetti')?.scrollIntoView({ behavior: 'smooth' })}
              className="flex-1 bg-white/5 hover:bg-white/10 border border-white/10 text-white rounded-full py-3 text-sm font-bold text-center transition-colors"
              data-testid="virtual-tour-cta-packages"
            >
              Vedi pacchetti
            </button>
          </div>
        </div>
      </div>

      {/* Colle Val d'Elsa — Il nostro territorio */}
      <div className="mt-12 relative overflow-hidden rounded-2xl" data-testid="colle-territorio-section">
        <img src={COLLE_PUZZLE_IMG} alt="Colle Val d'Elsa — Google Maps Virtual Tour" className="w-full h-auto object-cover rounded-2xl" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
          <p className="text-white font-black text-lg md:text-xl" style={{ fontFamily: "'Poppins',sans-serif", textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>
            Colle di Val d'Elsa — Il nostro territorio
          </p>
          <p className="text-white/80 text-sm mt-1" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
            52 milioni di visualizzazioni generate su Google Maps
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default VirtualTourSection;
